import { noop } from '@kofno/piper';
import { editTemplatesCheck, updateLearningCollection } from '.';
import LearningCollectionEditStore from '..';
import { LearningCollectionEditFormResource, Updating, Visibility } from '../Types';
import { nothing } from 'maybeasy';

const learningCollectionSuccess =
  (store: LearningCollectionEditStore, celebrationPage: Visibility) =>
  (resource: LearningCollectionEditFormResource) =>
    editTemplatesCheck(resource).map(({ template }) =>
      store.previewing(resource, template, celebrationPage),
    );

const update = (store: LearningCollectionEditStore, state: Updating) =>
  updateLearningCollection(store, state, nothing())
    .andThen(learningCollectionSuccess(store, state.celebrationPage))
    .orElse((error) =>
      editTemplatesCheck(state.learningCollectionEditFormResource).map(({ template }) =>
        store.editFormSubmissionError(state.learningCollectionEditFormResource, error, template),
      ),
    )
    .fork(store.templateLoadError, noop);

export default update;
